import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const BulkReviewPanel = ({ studentId }) => {
  const [selectedRecommendations, setSelectedRecommendations] = useState([]);

  const mockRecommendations = [
    {
      id: 'rec-1',
      field: 'Sciences de l\'Ingénieur',
      matchScore: 92,
      status: 'pending',
      generatedDate: '2026-02-10',
      aiReasoning: 'Forte performance en mathématiques et physique, intérêt marqué pour les technologies'
    },
    {
      id: 'rec-2',
      field: 'Économie et Gestion',
      matchScore: 88,
      status: 'pending',
      generatedDate: '2026-02-10',
      aiReasoning: 'Compétences analytiques solides, intérêt pour les affaires et la stratégie'
    },
    {
      id: 'rec-3',
      field: 'Sciences de la Santé',
      matchScore: 85,
      status: 'approved',
      generatedDate: '2026-02-09',
      aiReasoning: 'Empathie élevée, bonnes notes en biologie, désir d\'aider les autres'
    }
  ];

  const handleToggleSelection = (recId) => {
    setSelectedRecommendations(prev =>
      prev?.includes(recId)
        ? prev?.filter(id => id !== recId)
        : [...prev, recId]
    );
  };

  const handleBulkApprove = () => {
    console.log('Approving recommendations:', selectedRecommendations);
    setSelectedRecommendations([]);
  };

  const handleBulkReject = () => {
    console.log('Rejecting recommendations:', selectedRecommendations);
    setSelectedRecommendations([]);
  };

  return (
    <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-200 sticky top-24">
      <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
        <Icon name="CheckSquare" size={20} />
        Révision des Recommandations
      </h3>

      <div className="space-y-3 mb-4">
        {mockRecommendations?.map((rec) => (
          <div
            key={rec?.id}
            className={`p-4 border rounded-lg cursor-pointer transition-colors ${
              selectedRecommendations?.includes(rec?.id)
                ? 'border-blue-500 bg-blue-50' :'border-gray-200 hover:border-gray-300'
            }`}
            onClick={() => handleToggleSelection(rec?.id)}
          >
            <div className="flex items-start gap-3">
              <input
                type="checkbox"
                checked={selectedRecommendations?.includes(rec?.id)}
                onChange={() => handleToggleSelection(rec?.id)}
                className="mt-1"
              />
              <div className="flex-1">
                <div className="flex items-center justify-between mb-2">
                  <p className="font-medium text-gray-900">{rec?.field}</p>
                  <span className={`px-2 py-0.5 text-xs rounded ${
                    rec?.status === 'approved' ?'bg-green-100 text-green-700' :'bg-amber-100 text-amber-700'
                  }`}>
                    {rec?.status === 'approved' ? 'Approuvé' : 'En attente'}
                  </span>
                </div>
                <div className="flex items-center gap-2 mb-2">
                  <div className="flex-1 bg-gray-200 rounded-full h-1.5">
                    <div
                      className="bg-blue-500 h-1.5 rounded-full"
                      style={{ width: `${rec?.matchScore}%` }}
                    />
                  </div>
                  <span className="text-sm font-semibold text-gray-900">{rec?.matchScore}%</span>
                </div>
                <p className="text-xs text-gray-600">{rec?.aiReasoning}</p>
                <p className="text-xs text-gray-500 mt-2">
                  Généré le {new Date(rec?.generatedDate)?.toLocaleDateString('fr-FR')}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {selectedRecommendations?.length > 0 && (
        <div className="space-y-2 pt-4 border-t border-gray-200">
          <p className="text-sm text-gray-600 mb-3">
            {selectedRecommendations?.length} recommandation(s) sélectionnée(s)
          </p>
          <Button
            variant="default"
            iconName="Check"
            iconPosition="left"
            onClick={handleBulkApprove}
            className="w-full"
          >
            Approuver la Sélection
          </Button>
          <Button
            variant="outline"
            iconName="X"
            iconPosition="left"
            onClick={handleBulkReject}
            className="w-full"
          >
            Rejeter la Sélection
          </Button>
        </div>
      )}

      <div className="mt-6 pt-6 border-t border-gray-200">
        <h4 className="text-sm font-semibold text-gray-900 mb-3">Actions Rapides</h4>
        <div className="space-y-2">
          <button className="w-full px-4 py-2 text-sm text-left text-gray-700 hover:bg-gray-50 rounded-lg transition-colors flex items-center gap-2">
            <Icon name="Download" size={16} />
            Exporter les Recommandations
          </button>
          <button className="w-full px-4 py-2 text-sm text-left text-gray-700 hover:bg-gray-50 rounded-lg transition-colors flex items-center gap-2">
            <Icon name="RefreshCw" size={16} />
            Régénérer avec IA
          </button>
          <button className="w-full px-4 py-2 text-sm text-left text-gray-700 hover:bg-gray-50 rounded-lg transition-colors flex items-center gap-2">
            <Icon name="Share2" size={16} />
            Partager avec Collègues
          </button>
        </div>
      </div>
    </div>
  );
};

export default BulkReviewPanel;